<script setup lang="ts">
defineProps<{
  variant?: CardProps["variant"];
  active?: boolean;
  pointer?: boolean;
  selected?: boolean;
}>();
</script>

<script lang="ts">
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export type CardProps = VariantProps<typeof card>;

export const card = cva([
  "box-decoration-clone select-auto ligatures-none",
], {
  variants: {
    variant: {
      link: "rounded-md border border-transparent py-0.5 text-blue-600 underline underline-offset-2",
      "inline-card": "rounded-md border border-blue-200 px-1 py-0.5 text-blue-700",
      canvas: "rounded-md border border-blue-300 bg-blue-50 px-1 py-0.5 text-blue-700",
      section: "rounded-md border px-1 py-0.5",
      broken: "rounded-md border border-slate-200 bg-slate-100 px-1 py-0.5 text-slate-400",
    },
    active: {
      true: "", // "bg-blue-100",
      false: "",
    },
    pointer: {
      true: "cursor-pointer",
      false: "cursor-default",
    },
    selected: {
      true: "ring-1 ring-blue-600 ring-offset-0",
      false: "",
    },
  },
  defaultVariants: {
    variant: "inline-card",
  },
});
</script>

<template>
  <span
    :class="card({ variant, active, pointer, selected })"
  >
    <slot />
  </span>
</template>
